import axiosInstance from './axios-instance';

export const authGatewayApi = {
  verifyPassword: async (body) => {
    const result = await axiosInstance.post(
      `/api/v1/publisher/auth-gateway/add-recovery-email`,
      body
    );
    return result;
  },

  verifyOtp: async (body) => {
    const result = await axiosInstance.post(
      `/api/v1/publisher/auth-gateway/verify-recovery-email`,
      body
    );
    return result;
  },

  requestRecoverAccount: async () => {
    const result = await axiosInstance.post(
      `/api/v1/publisher/auth-gateway/request-recover-account`
    );
    if (result.status === 200) return result.data;
  },

  verifyOtpRecoverAccount: async () => {
    const result = await axiosInstance.post(
      `/api/v1/publisher/auth-gateway/verify-recover-account`
    );
    if (result.status === 200) return result.data.data;
  },

  sendOtpNewAccount: async () => {
    const result = await axiosInstance.post(`/api/v1/publisher/auth-gateway/send-verify-new-email`);
    if (result.status === 200) return result.data.data;
  },

  updateNewAccount: async () => {
    const result = await axiosInstance.post(`/api/v1/publisher/auth-gateway/update-new-email`);
    if (result.status === 200) return result.data.data;
  }
};
